export default class TaskFinishParam {
    id: string;
    remark: string;

    constructor() {
        this.id = "";
        this.remark = "";
    }
}